import ajax from './ajax';
import router from './router';

export default {
  ajax,
  router,
};
